import { motion } from "framer-motion";
import { TreePine, Home, Flame, Layers, Scissors, Sparkles, ArrowUpRight } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { useContent } from "../../context/ContentContext";
import { mediaUrl } from "../../lib/api";

const ICONS = { TreePine, Home, Flame, Layers, Scissors, Sparkles };

export default function Services() {
  const { t, pick } = useLang();
  const { content } = useContent();
  const services = content?.services || [];

  return (
    <section id="services" className="relative py-24 md:py-32 px-5 md:px-10" data-testid="services-section">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-acid mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-acid" /> {t("services_kicker")}
            </p>
            <h2 className="font-display uppercase text-5xl md:text-7xl leading-[0.9] text-white">
              {t("services_title")}
            </h2>
          </div>
          <p className="font-mono text-silver text-sm max-w-xs">
            01 — 0{services.length}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {services.map((s, i) => {
            const Icon = ICONS[s.icon] || Sparkles;
            const img = mediaUrl(s.image);
            return (
              <motion.div
                key={s.id || i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
                className="group relative bg-obsidian p-8 md:p-10 min-h-[300px] flex flex-col justify-between overflow-hidden"
                data-testid={`service-card-${i}`}
              >
                {img && (
                  <div
                    className="absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-25 transition-opacity duration-500"
                    style={{ backgroundImage: `url(${img})` }}
                  />
                )}
                <div className="relative z-10 flex items-start justify-between">
                  <span className="font-mono text-sm text-acid">0{i + 1}</span>
                  <ArrowUpRight className="text-white/20 group-hover:text-acid group-hover:rotate-45 transition-all duration-300" />
                </div>
                <div className="relative z-10">
                  <Icon className="text-acid mb-5" size={40} strokeWidth={1.5} />
                  <h3 className="font-heading uppercase text-2xl md:text-3xl font-semibold text-white leading-tight mb-3">
                    {pick(s, "title")}
                  </h3>
                  <p className="text-silver text-sm leading-relaxed">{pick(s, "desc")}</p>
                </div>
                <div className="absolute bottom-0 left-0 h-1 w-0 bg-acid group-hover:w-full transition-all duration-500" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
